import { tv } from 'tailwind-variants';

type Color = 'primary' | 'secondary' | 'success' | 'warning' | 'danger';

type Size = 'sm' | 'md';

type BannerProps = {
  children?: React.ReactNode;
  color?: Color;
  size?: Size;
};

const bannerVariants = tv({
  base: 'flex flex-col items-center justify-between gap-2.5 rounded p-2.5 sm:flex-row sm:gap-5 sm:px-5',
  variants: {
    color: {
      primary: 'bg-primary/10',
      secondary: 'bg-gray/10',
      success: 'bg-success/10',
      warning: 'bg-warning/10',
      danger: 'bg-danger/10',
    },
    size: {
      sm: 'min-h-10 py-1',
      md: 'py-2.5',
    },
  },
  defaultVariants: {
    color: 'primary',
    size: 'md',
  },
});

const Banner = ({ children, color, size }: BannerProps) => {
  return <div className={bannerVariants({ color, size })}>{children}</div>;
};

export default Banner;
